/**
 * The agent's self-reported configuration, one cell per key, in the Edge Fleet
 * drawer's "Actually running" section. Flat values keep the compact two-column
 * cell; a nested value (capabilities, failure counts) takes the full width and
 * one line per entry, instead of "[object Object]".
 */

import { configValueLines, isNestedValue } from './effective-config-format';

export function EffectiveConfigGrid({ config }: { config: Record<string, unknown> }) {
  return (
    <div className="grid grid-cols-2 gap-2 text-[11px]">
      {Object.keys(config)
        .sort()
        .map((k) => {
          const value = config[k];
          const lines = configValueLines(value);
          if (isNestedValue(value)) {
            return (
              <div key={k} className="glass-lite rounded px-2 py-1 col-span-2 space-y-0.5">
                <span className="text-muted-foreground">{k}</span>
                <ul className="font-mono text-foreground/90 space-y-0.5">
                  {lines.map((line, i) => (
                    <li key={i} className="break-words">
                      {line}
                    </li>
                  ))}
                </ul>
              </div>
            );
          }
          return (
            <div key={k} className="glass-lite rounded px-2 py-1 flex justify-between gap-2">
              <span className="text-muted-foreground truncate">{k}</span>
              <code className="font-mono truncate">{lines[0]}</code>
            </div>
          );
        })}
    </div>
  );
}
